import React, { useEffect, useState } from "react";
import { Button, Container, Modal, Table } from "react-bootstrap";
import { TextField } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { GetAllClientsMowakelAction } from "../../../../redux/actions/ClientAction";
import { ToastContainer } from "react-toastify";
import notify from "../../../Notifcation";
import axios from "axios";
import fileDownload from "js-file-download";
const NamemowakelSearchAj = ({ userData }) => {
  const [Search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const PageSize = 2000;

  const ALL = useSelector((state) => state.ClientR.GetClientsMo);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      GetAllClientsMowakelAction(
        `SearchTerm=${Search}&PageSize=${PageSize}&ClientType=Client`
      )
    );
  }, [Search]);

  const res = useSelector((state) => state.ClientR.InsertClients);

  useEffect(() => {
    if (loading === false) {
      setTimeout(() => setLoading(true), 2000);
      if (res) {
        if (res.status === 200 || res.status === 201) {
          if (
            res.data &&
            res.data.ResponseMessage === "Great, Client created Successfully"
          ) {
            dispatch(GetAllClientsMowakelAction("ClientType=Client"));
            notify("تم اضافة البيانات بنجاح", "success");
          }
        } else if (res.status !== 200 || res.status !== 201) {
          // if (res.data && res.data.ResponseMessage==="PhoneNumber or Password is incorrect!") {
          //   notify("خطأ في كلمة السر او رقم الهاتف", "error");
          // }
          // else
          notify("حدث خطأ حاول مرة اخرى", "error");
        }
        // setLoading(true);
      }
    }
  }, [loading]);
  const [popup, setpopup] = useState(false);
  const [ContentFile, setContentFile] = useState("");
  const handleClosepopup = () => {
    setpopup(false);
    setpopup("");
    setContentFile("");
  };
  const handleShowpopup = (item) => {
    setpopup(true);
    setContentFile(item);
  };
  const handleDownload = (url, filename) => {
    axios
      .get(url, {
        responseType: "blob",
      })
      .then((res) => {
        fileDownload(res.data, filename);
        setpopup(false);
      });
  };
  return (
    <>
      <div className="enterr">
        <Container>
          <div className="inputs-container">
            {/* <div className="inp-container">
              <TextField
                
                value={Namee}
                onChange={(e) => setNamee(e.target.value)}
                label={
                  <Typography sx={{ fontSize: "17", fontFamily: "Almarai" }}>
                    اسم الموكل
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                }
                variant="outlined"
                //   className="ww"
              />
            </div>
            <div className="inp-container">
              <TextField
                
                value={Phone}
                onChange={(e) => setPhone(e.target.value)}
                label={
                  <Typography sx={{ fontSize: "17", fontFamily: "Almarai" }}>
                    رقم الهاتف
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                }
                variant="outlined"
                //   className="ww"
              />
            </div>
            <div className="inp-container">
              <TextField
                
                label="العنوان"
                variant="outlined"
                value={Addreess}
                onChange={(e) => setAddreess(e.target.value)}
                //   className="ww"
              />
            </div>
            <div className="inp-container">
              <TextField
                
                label="ملاحظات"
                value={Note}
                onChange={(e) => setNote(e.target.value)}
                variant="outlined"
                //   className="ww"
              />
            </div>
            <div className="inp-container">
              <TextField
                
                label="أرشيف المستندات"
                variant="outlined"
                //   className="ww"
              />
              <i
                onClick={importData}
                className="ty fa-solid fa-paperclip"
                style={{ color: "#1866ec" }}
              ></i>

            </div> */}
            {/* <div className="inp-container">
              {selectedFile && (
                <div className="fi">
                  <a
                    href={FileeBase64 ? FileeBase64 : selectedFile}
                    target="blank"
                    download={selectedFile.name}
                  >
                    {selectedFile.name ? (
                      selectedFile.name
                    ) : (
                      <i
                        className=" fa-solid fa-paperclip"
                        style={{ color: "#1866ec" }}
                      ></i>
                    )}
                  </a>
                  <div style={{ display: "block" }}>
                    Attach File
                  </div>
                  <button
                    style={{ background: "transparent" }}
                    className="buttonadd d"
                  >
                    <i
                      onClick={(idx) => deleteFile(idx)}
                      className="fs fa-solid fa-trash-can icon-red"
                      style={{ color: "red" }}
                    ></i>
                  </button>
                </div>
              )}
            </div> */}

            <div className="inp-container"></div>
            <div className="inp-container"></div>
          </div>

          <div className="inp-container">
            <TextField
              onChange={(e) => setSearch(e.target.value)}
              value={Search}
              label={"ابحث"}
              inputProps={{ maxLength: 120 }}
              type="text"
              variant="outlined"
              //   className="ww"
            />
          </div>
        </Container>{" "}
        <Table
          id="my-table"
          className="maint"
          responsive
          striped
          bordered
          hover>
          <thead>
            <tr>
              <th>
                اسم الموكل <i className="fa-solid fa-hashtag"></i>
              </th>
              <th>
                رقم الهاتف <i className="fa-solid fa-hashtag"></i>
              </th>
              <th>
                العنوان <i className="fa-solid fa-hashtag"></i>
              </th>
              <th>
                الوصف <i className="fa-regular fa-calendar-check"></i>
              </th>
              <th>
                ارشيف المستندات <i className="fa-regular fa-calendar-check"></i>
              </th>
            </tr>
          </thead>
          <tbody>
            {ALL && ALL.Data
              ? ALL.Data.map((item) => (
                  <tr key={item.Id}>
                    <td>{item.Name}</td>
                    <td>{item.phoneNumber}</td>
                    <td>{item.Address}</td>
                    <td>{item.note}</td>
                    <td>
                      {" "}
                      {item.FileUrl !== null ? (
                        <button
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                          }}
                          onClick={() => handleShowpopup(item.FileUrl)}>
                          {" "}
                          <i className="fa-solid fa-paperclip"></i>
                        </button>
                      ) : (
                        " "
                      )}
                    </td>
                    {/* <td className="icon-w" onClick={() => Update(item)}>
                      <i
                        className="fa fa-solid fa-pen-to-square icon-blue"
                        style={{ color: "#333" }}
                      ></i>
                    </td> */}
                    {/* <td className="icon-w">
                      {" "}
                      <i
                        onClick={() => handleShoweDelete(item.id)}
                        className="fs fa-solid fa-trash-can icon-red"
                        style={{ color: "#333" }}
                      ></i>
                    </td> */}

                    {/* <td className="icon-w">
                      <i
                        onClick={() => Showw(item)}
                        className="fa-solid fa-eye"
                        style={{ color: "#333" }}
                      ></i>
                    </td> */}
                  </tr>
                ))
              : null}
          </tbody>
        </Table>
      </div>
      <ToastContainer autoClose={1200} />

      <div className="popimg">
        <Modal
          show={popup}
          onHide={handleClosepopup}
          backdrop="static"
          centered
          keyboard={false}
          contentClassName="popimg"
          style={{ width: "90%", margin: "0px auto", textAlign: "center" }}>
          <Modal.Header closeButton>
            <Modal.Title>عرض المستند</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {" "}
            {ContentFile.split(".").pop().toLowerCase() === "png" ||
            ContentFile.split(".").pop().toLowerCase() === "jpg" ||
            ContentFile.split(".").pop().toLowerCase() === "jpeg" ||
            ContentFile.split(".").pop().toLowerCase() === "svg" ? (
              <img src={ContentFile} alt="" />
            ) : (
              <Button
                variant="secondary"
                className="close"
                onClick={() =>
                  handleDownload(
                    ContentFile,
                    `document.${ContentFile.split(".").pop().toLowerCase()}`
                  )
                }>
                تحميل ملف بصيغة {ContentFile.split(".").pop().toLowerCase()}{" "}
                <i className="fa-solid fa-file-export"></i>
              </Button>
            )}
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              className="close"
              onClick={handleClosepopup}>
              إغلاق
            </Button>
            {ContentFile.split(".").pop().toLowerCase() === "png" ||
            ContentFile.split(".").pop().toLowerCase() === "jpg" ||
            ContentFile.split(".").pop().toLowerCase() === "jpeg" ||
            ContentFile.split(".").pop().toLowerCase() === "svg" ? (
              <Button
                variant="secondary"
                className="close"
                onClick={() =>
                  handleDownload(
                    ContentFile,
                    `document.${ContentFile.split(".").pop().toLowerCase()}`
                  )
                }
                // onClick={() =>
                //   downloadFile({ url: ContentFile, filename: "newfile.png" })
                // }
              >
                تحميل الصورة
              </Button>
            ) : null}
            {/* <a  href={ContentFile}  className="close" >
            تحميل الملف
          </a> */}
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
};
export default NamemowakelSearchAj;
